import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardPageNumber: 0,
  reportPageNumber: 0,
  reportSearchValue: "",
  dashboardSearchValue: "",
  selectBoxInReport: "",

  fileType: 0,
  selectedFileReports: [],
  selectedFileFormatId: null,
  agencyTypeStoring: 0,
};
export const searchPaginationSlice = createSlice({
  name: "searchPaginationSlice",
  initialState: initialState,
  reducers: {
    setDashboardPageNumber: (state, { payload }) => {
      state.dashboardPageNumber = payload;
    },
    setDashboardSearchValue: (state, { payload }) => {
      state.dashboardSearchValue = payload;
    },
    setReportPageNumber: (state, { payload }) => {
      state.reportPageNumber = payload;
    },
    setReportSearchValue: (state, { payload }) => {
      state.reportSearchValue = payload;
    },
    setSelectBoxInReport: (state, { payload }) => {
      state.selectBoxInReport = payload;
    },

    clearsearchPaginationSlice: () => {
      return initialState;
    },
    setFileType: (state, { payload }) => {
      state.fileType = payload;
    },
    setSelectedFileReports: (state, { payload }) => {
      state.selectedFileReports = payload;
    },
    setSelectedFileFormatId: (state, { payload }) => {
      state.selectedFileFormatId = payload;
    },
    setFilesPartsEmpty: (state, { payload }) => {
      state.fileType = 0;

      state.selectedFileReports = [];
      state.selectedFileFormatId = null;
    },
    setAgencyTypeStoring: (state, { payload }) => {
      state.agencyTypeStoring = payload;
    },
  },
});

export const {
  setDashboardPageNumber,
  clearsearchPaginationSlice,
  setReportPageNumber,
  setReportSearchValue,
  setDashboardSearchValue,
  setSelectBoxInReport,

  setFileType,
  setSelectedFileReports,
  setSelectedFileFormatId,
  setFilesPartsEmpty,
  setAgencyTypeStoring,
} = searchPaginationSlice.actions;

export default searchPaginationSlice.reducer;
